<template>
    <div class="group-row">
        <div v-for="(child, idx) in children" :key="idx" class="show-column">
            <tr-text class="column" v-bind="child.props.label" :tracker="tracker"
                    @edit-tr="$emit('edit-tr', $event)"></tr-text>
            <component :is="child.tag"
                v-bind="child"
                :index="idx"
                :tracker="tracker"
                :showLabel="false"
                @edit-tr="$emit('edit-tr', $event)"
            ></component>
        </div>
    </div>
</template>

<script>
import TrText               from "@/components/translation/TrText"
import I18nText             from "@/components/i18n/I18nText"
import I18nEditbox          from "@/components/i18n/I18nEditbox"
import I18nCheckbox         from "@/components/i18n/I18nCheckbox"
import I18nCombobox         from "@/components/i18n/I18nCombobox"
import I18nGetsum           from "@/components/i18n/I18nGetsum"

export default {
    name: "I18nGroupMultirow",
    components: {TrText, I18nText, I18nEditbox, I18nCheckbox, I18nCombobox, I18nGetsum},
    props: {
        tracker: Array,
        index: Number,
        children: Array,
        props: Object,
        showLabel: {default: true}
    }
}
</script>

<style>
    .group-row {
        position: relative;
        display: flex;
    }
/*
    .show-column {
        border: 1px dotted black;
    }
*/
</style>